import React, { useEffect, useMemo, useState } from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormTitle from "../../../../library/form/components/FormTitle";
import RolePrivilegeRow from './RolePrivilegeRow'
import { UiView, UiViewHeading, UiTitle } from "../../../../library/layout/Index";
import Icon from '../../../../library/decor/SarasIcons';
import { useStickyTop } from '../../../../library/hooks/appearance/useStickyTop';

const getMenuFilterKey = (row = {}) => {
    const dataList = row.dataList || {};
    return dataList.appMenuSortKey || '9999';
};

const sortRows = (firstRow, secondRow) => {
    const firstMenuSortKey = Number((firstRow.dataList && firstRow.dataList.appMenuSortKey) || 0);
    const secondMenuSortKey = Number((secondRow.dataList && secondRow.dataList.appMenuSortKey) || 0);

    if (firstMenuSortKey !== secondMenuSortKey) {
        return firstMenuSortKey - secondMenuSortKey;
    }

    const firstDocument = ((firstRow.rowValues && firstRow.rowValues.docType && firstRow.rowValues.docType.val) || '').toLowerCase();
    const secondDocument = ((secondRow.rowValues && secondRow.rowValues.docType && secondRow.rowValues.docType.val) || '').toLowerCase();
    return firstDocument.localeCompare(secondDocument);
};

const RoleDocumentRow = (props) => {
    const { formObject, viewData } = props;
    const [activeFilter, setActiveFilter] = useState('all');
    const safeViewData = viewData || {};

    const isEmbedded = false;

    const stickyElement = useStickyTop(isEmbedded ? 0 : 35, null);
    // console.log("viewData", viewData);

    const rows = useMemo(() => {
        return Object.values(safeViewData).sort(sortRows);
    }, [safeViewData]);

    const filterOptions = useMemo(() => {
        const menuMap = {};

        rows.forEach((row) => {
            const key = getMenuFilterKey(row);
            if (!menuMap[key]) {
                const dataList = row.dataList || {};
                menuMap[key] = {
                    key,
                    label: dataList.appMenuName || 'Unknown',
                    appMenuSortKey: Number(dataList.appMenuSortKey || 0),
                    appMenuImage: dataList.appMenuImage || '',
                    appMenuIcon: Icon[dataList.appMenuImage]
                };
            }
        });

        const dynamicOptions = Object.values(menuMap)
            .sort((firstMenu, secondMenu) => {
                if (firstMenu.appMenuSortKey !== secondMenu.appMenuSortKey) {
                    return firstMenu.appMenuSortKey - secondMenu.appMenuSortKey;
                }
                return firstMenu.label.localeCompare(secondMenu.label);
            })
            .map(({ key, label, appMenuImage, appMenuIcon }) => ({ key, label, appMenuImage, appMenuIcon }));

        return [{ key: 'all', label: 'All', appMenuIcon: Icon.all }, ...dynamicOptions];
    }, [rows]);

    useEffect(() => {
        const hasActiveFilter = filterOptions.some((option) => option.key === activeFilter);
        if (!hasActiveFilter) {
            setActiveFilter('all');
        }
    }, [activeFilter, filterOptions]);

    const filteredRows = useMemo(() => {
        if (activeFilter === 'all') {
            return rows;
        }

        return rows.filter((row) => getMenuFilterKey(row) === activeFilter);
    }, [activeFilter, rows]);

    if (!viewData)
        return(null)
    
    return (
        <UiView className="uiSpacer20 uiRolePrivilegeView" >
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Assigned Privileges' />
                </UiTitle>
                <div className="uiSpacerH10">
                    <FormButton formObject={formObject} ksc="ctrl+a" rowKey=""
                        action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Add New" />}></FormButton>
                </div>
            </UiViewHeading>

            <div 
                className={`uiStickyElement ${stickyElement.isScrolling ? "uiStickyHeaderScrolling" : ""}`}
                style={{ '--sticky-top': `${stickyElement.isScrolling ? stickyElement.stickyTop : 0}px` }} 
            >
                {
                    filterOptions.map((option) => {
                        const MenuIcon = option.appMenuIcon;

                        return (
                            <button
                                key={option.key}
                                type="button"
                                onClick={() => setActiveFilter(option.key)}
                                className='uiActionButton'
                                style={{
                                    fontSize: '14px',
                                    marginRight: '8px',
                                    marginBottom: '8px',
                                    opacity: activeFilter === option.key ? 1 : 0.65,
                                    borderBottom: activeFilter === option.key ? '2px solid currentColor' : '2px solid transparent'
                                }}
                            >
                                <div className='uiFlexBox uiSpacerH5'>
                                {MenuIcon ? (
                                    <MenuIcon className='uiMenuIcon' />
                                ) : null}
                                {option.label}
                                </div>
                            </button>
                        )
                    })
                }
            </div>

            <div className={`uiSearchResults uiStickyTable ${stickyElement.isScrolling ? "uiStickyHeaderScrolling" : ""}`}
                style={{ '--sticky-top': `${stickyElement.isScrolling ? 80: 0}px` }} 
            >
                <table className="uiTable" style={{ width: '100%', minWidth: '980px' }}>
                    <thead>
                        <tr className='uiGridRowType_2'>
                            <th className='uiCenter uiColumn200'>Document</th>
                            <th className='uiCenter uiColumn70'>Menu</th>
                            <th className='uiCenter uiColumn70'>Create</th>
                            <th className='uiCenter uiColumn70'>View</th>
                            <th className='uiCenter uiColumn70'>Edit</th>
                            <th className='uiCenter uiColumn70'>Delete</th>
                            <th className='uiCenter uiColumn70'>Cancel</th>
                            <th className='uiCenter uiColumn150'>Advanced</th>
                            <th className='uiCenter uiColumn70'>Action</th>
                        </tr>
                    </thead>
                    <tbody className='uiTableBody'>
                        {
                            filteredRows.map((row) => (
                                <RolePrivilegeRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={row.rowKey} />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </UiView>
    )
}

export default withView(RoleDocumentRow, "rolePrivilege", "rolePrivilege")